import React from 'react'

interface ErrorBoundaryState {
  error: unknown
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: unknown) {
    return { error }
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Caught in ErrorBoundary:', error, errorInfo)
  }

  render() {
    if (this.state.error) {
      return <pre className="text-red-600 whitespace-pre-wrap p-4">{String(this.state.error)}</pre>
    }
    return this.props.children
  }
}
